import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatTableDataSource, MatSort, Sort, MAT_DATE_FORMATS } from '@angular/material';
import { DEFAULT_FORMATS, dateFormat } from 'src/app/share/utils/common-utils';
import { EsDeptInfo, EsWarehouseService } from 'src/app/restapi/be-esquery';
import { EsShippingStatisticalData } from 'src/app/restapi/be-esquery/model/esShippingStatisticalData';
import { take, tap, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as XLSX from 'xlsx';
import * as _moment from 'moment';

const moment = _moment;

@Component({
  selector: 'app-warehouse-shipping',
  templateUrl: './warehouse-shipping.component.html',
  styleUrls: ['./warehouse-shipping.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: DEFAULT_FORMATS }
  ]
})
export class WarehouseShippingComponent implements OnInit, OnDestroy {

  @ViewChild('TABLE') table: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  form: FormGroup;
  dataList: Array<EsShippingStatisticalData> = [];
  dataSource: MatTableDataSource<EsShippingStatisticalData> = new MatTableDataSource([]);
  displayedColumns = ['search_yyyy_mm', 'recycle_place_name', 'give_good_cate', 'give_good_detail_cate', 'general_shipping',
    'event_shipping', 'sharing_shipping', 'no_tag_shipping_general', 'no_tag_shipping_material', 'no_tag_shipping_fixtures'];
  minDate = moment().add(-3, 'month');
  maxDate = moment();

  constructor(
    private fb: FormBuilder,
    private esWarehouseService: EsWarehouseService
  ) { }

  ngOnInit() {
    this.initForm();

    this.sort.sortChange.pipe(
      tap((sort: Sort) => {
        this.initPage(sort);
      }),
      takeUntil(componentDestroyed(this)),
    ).subscribe();
  }

  ngOnDestroy() { }

  initForm() {
    this.form = this.fb.group({
      gte_date: this.minDate,
      lte_date: this.maxDate,
      dept_info: null
    });
  }

  get fc_gteDate() { return this.form.get('gte_date'); }
  get fc_lteDate() { return this.form.get('lte_date'); }
  get fc_deptInfo() { return this.form.get('dept_info'); }

  onChangeStartDate() {
    const limitDate = moment(this.fc_gteDate.value).add(3, 'month');
    this.minDate = this.fc_gteDate.value;

    if (this.fc_gteDate.value > this.fc_lteDate.value) {
      this.fc_lteDate.setValue(this.fc_gteDate.value);
    }

    if (limitDate < this.fc_lteDate.value) {
      this.fc_lteDate.setValue(limitDate);
    }
  }

  onChangeEndDate() {
    const limitDate = moment(this.fc_lteDate.value).add(-3, 'month');

    if (limitDate > this.fc_gteDate.value) {
      this.fc_gteDate.setValue(limitDate);
      this.minDate = limitDate;
    }
  }

  selectDept(value: EsDeptInfo) {
    if (!value || value == null) {
      this.fc_deptInfo.setValue(null);
      return;
    }

    this.fc_deptInfo.setValue(value);
    this.search();
  }

  initPage(sort?: Sort) {
    if (!this.dataList) this.dataList = [];

    let sorted = this.dataList;
    if (sort) {
      sorted = this.dataList.sort((a: EsShippingStatisticalData, b: EsShippingStatisticalData) => {
        let result = 0;
        if (a[sort.active] == undefined) a[sort.active] = "";
        if (b[sort.active] == undefined) b[sort.active] = "";

        if (a[sort.active] < b[sort.active]) result = -1;
        else if (a[sort.active] > b[sort.active]) result = 1;
        return result * (sort.direction === 'asc' ? 1 : -1);
      });
    }

    this.dataList = sorted;
    this.dataSource = new MatTableDataSource<EsShippingStatisticalData>(this.dataList);
  }

  search() {
    this.shippingGet();
  }

  exportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, '전체출고통계');
    XLSX.writeFile(wb, '전체출고통계.xlsx');
  }

  shippingGet() {
    this.dataList = [];

    this.esWarehouseService.warehouseRecyclePlaceShippingStatisticalTableGet(
      dateFormat(this.fc_gteDate.value),
      dateFormat(this.fc_lteDate.value),
      this.fc_deptInfo.value != null ? this.fc_deptInfo.value.dept_id : null
    ).pipe(
      take(1)
    ).subscribe((res: Array<EsShippingStatisticalData>) => {
      this.dataList = res;
      this.initPage(this.sort);
    },
      (err) => {
        console.error(err);
        this.initPage(this.sort);
      }
    );
  }

}